import { useTexts } from './useTexts'
import { form } from '../DriverActivityForm/formState'

export function ReasonsForNotCompletedOrdersCount() {
  const reasonsCount = form.useFormField('reasonsForNotCompletedOrders')
  const texts = useTexts()

  return (
    <form.Fieldset spacing={1}>
      <form.SectionTitle>{`${texts.reasonsTitle} (${reasonsCount.field.value?.length || 0})`}</form.SectionTitle>
      <form.SectionSubtitle>{texts.reasonsSubtitle}</form.SectionSubtitle>
    </form.Fieldset>
  )
}
